var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60DD4D"
    },
    d: "M440.325,172.19c0.111-1.872,0.167-3.747,0.167-5.621c0-52.311-42.557-94.868-94.868-94.868 c-4.082,0-8.144,0.26-12.166,0.777c-8.68-18.87-21.92-35.214-38.87-47.838C272.944,8.52,247.205,0,220.151,0 C151.367,0,95.407,55.96,95.407,124.743c0,3.062,0.112,6.121,0.335,9.17c-20.437,4.437-39.147,14.803-53.972,30.132 c-19.354,20.014-30.013,46.373-30.013,74.222c0,42.224,24.658,79.952,62.421,97.161c2.934,18.396,11.659,35.326,25.201,48.557 c16.401,16.025,38.063,24.85,60.996,24.85c21.938,0,42.912-8.171,59.056-23.007c12.083-11.105,20.686-25.212,25.026-40.743h23.087 c4.342,15.531,12.945,29.639,25.026,40.743c16.143,14.836,37.116,23.007,59.056,23.007c22.099,0,43.183-8.276,59.371-23.304 c12.876-11.953,21.737-27.309,25.653-44.152c37.024-11.069,63.592-45.66,63.592-85.189 C500.243,217.898,475.443,184.37,440.325,172.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C47A"
    },
    d: "M440.325,172.19c0.111-1.872,0.167-3.747,0.167-5.621c0-52.311-42.557-94.868-94.868-94.868 c-4.082,0-8.144,0.26-12.166,0.777c-8.68-18.87-21.92-35.214-38.87-47.838C282.794,15.855,269.777,9.348,256,5.226v339.861h11.543 c4.342,15.531,12.945,29.639,25.026,40.743c16.143,14.836,37.116,23.007,59.056,23.007c22.099,0,43.183-8.276,59.371-23.304 c12.876-11.953,21.737-27.309,25.653-44.152c37.024-11.07,63.592-45.66,63.592-85.189 C500.243,217.898,475.443,184.37,440.325,172.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE33"
    },
    d: "M324.776,512l-33.114-57.313v-142.01c0-19.696-15.966-35.661-35.661-35.661l0,0 c-19.695,0-35.661,15.966-35.661,35.661v142.01L187.224,512H324.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M256,512h68.776l-33.114-57.313v-142.01c0-19.695-15.966-35.661-35.661-35.661L256,512L256,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF318F"
    },
    cx: 181.488,
    cy: 328.6,
    r: 17.194
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF318F"
    },
    cx: 112.712,
    cy: 225.436,
    r: 17.194
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF318F"
    },
    cx: 181.488,
    cy: 133.735,
    r: 17.194
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF256B"
    },
    cx: 330.503,
    cy: 328.6,
    r: 17.194
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF256B"
    },
    cx: 255.995,
    cy: 213.973,
    r: 17.194
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF256B"
    },
    cx: 399.279,
    cy: 236.899,
    r: 17.194
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF256B"
    },
    cx: 330.503,
    cy: 156.66,
    r: 17.194
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.99d5ed53e75ca25cce0340505ba8b268.svg";
export { ForwardRef as ReactComponent };